@if (isAuthPage()) {
    <router-outlet></router-outlet>
    <div class="lang-switcher">
        <app-lang-switcher></app-lang-switcher>
    </div>
} @else {
    <div class="app-wrapper">
        <app-sidebar [items]="sideBarItems()" (itemClicked)="onSidebarItemClick($event)">
            <app-lang-switcher></app-lang-switcher>
        </app-sidebar>

        <div class="app-main">
            <app-navbar [username]="authService.getUser()?.userName"
                        [orgName]="authService.getUser()?.orgName"
                        [portal]="navbarService.portal()"
                        (logout)="logout()">
            </app-navbar>

            <ng-container #vcr></ng-container>

            <div class="content">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
}
